import { useState } from "react";
import { ChakraProvider } from "@chakra-ui/provider";
import Navbar from "./components/navbar/navbar";
import Home from "./components/home/home";
import theme from "./theme";
import "./App.css";
import { Routes, Route } from "react-router-dom";
import ScrollAnimation from "react-animate-on-scroll";
import SignInForm from "./components/signup/signin";
import SignUpForm from "./components/signup/signup";
import CollabRegistration from "./components/collaboration-signup/collaboration-registration";
import { AuthContextProvider } from "./components/auth-check/authContext";
import RequireAuth from "./components/auth-check/requireAuth";
import Dashboard from "./components/dashboard/dashboard";
import OnlyAuthorized from "./components/auth-check/onlyAuthorized";
import { HomepageContextProvider } from "./components/home/homepageContext";
import NotFound from "./components/notFound";

function App() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <ChakraProvider theme={theme}>
      <AuthContextProvider>
        <HomepageContextProvider>
          <Navbar isMenuOpen={isMenuOpen} setIsMenuOpen={setIsMenuOpen} />
          <Routes>
            <Route
              path='/'
              element={
                <ScrollAnimation animateIn='fadeIn' animateOnce={true}>
                  <Home isMenuOpen={isMenuOpen} />
                </ScrollAnimation>
              }
            />

            <Route
              path='signup'
              element={
                <OnlyAuthorized>
                  <SignUpForm />
                </OnlyAuthorized>
              }
            />
            <Route
              path='signin'
              element={
                <OnlyAuthorized>
                  <SignInForm />
                </OnlyAuthorized>
              }
            />
            <Route
              path='collab-registration'
              element={<CollabRegistration />}
            />
            <Route
              path='dashboard/*'
              element={
                <RequireAuth>
                  <Dashboard />
                </RequireAuth>
              }
            />
            <Route path='*' element={<NotFound />} />
          </Routes>
        </HomepageContextProvider>
      </AuthContextProvider>
    </ChakraProvider>
  );
}

export default App;
